/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Search from "./components/Search";
import Table from "./components/Table";
import { dutyDetail } from "../../Api";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { setTitlePage, isOnlyNumbers } from "../../Functions";
import PaginationComponent from "../../components/PaginationComponent/PaginationComponent";
import { AlertDialog } from "../../components/Dialog/Dialog";

const Tariff = () => {
    const [showAlertError, setShowAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('No se encontraron resultados para tu búsqueda.');
    const [state, setState] = useState<any>({
        data: [],
        headers: [],
        pages: 0,
        pageIndex: 0,
        pageSize: 10,
        loading: false,
    });

    const [filters, setFilters] = useState<any>({})

    useEffect(() => {
        setTitlePage('Aranceles')
    }, [])

    const handleError = (e: any) => {
        console.log(e)
    }

    const _handleGetData = async (pageIndex = 0, pageSize = 10, fnFilters: any = null) => {
        try {
            let data: any = { ...filters };
            data.paginate = pageIndex;
            data.numberrecords = pageSize;

            if (fnFilters) {
                data = { ...data, ...fnFilters };
                data.paginate = 1;
                setFilters({ ...fnFilters })
            }

            if(data.codigo_prestacion.length > 0 && (!isOnlyNumbers(data.codigo_prestacion) || data.codigo_prestacion.length > 15)){
              setMessageAlertError('El formato de Código Prestación, es incorrecto!');
              setShowAlertError(true);
              return;
            }
            if(data.nombre_prestacion.length > 0 && data.nombre_prestacion.length > 50){
              setMessageAlertError('El limite de caracteres en Nombre Prestación es 50!');
              setShowAlertError(true);
              return;
            }
            setState({ ...state, loading: true })
            const response: any = await dutyDetail(data);
            const { totalrecords, paginate, totalpaginate } = response.data.pagination;
            setState({
                ...state,
                data: response.data.records,
                headers: response.data.headers,
                pageCount: parseInt(totalrecords),
                pageIndex: parseInt(paginate),
                pageSize: pageSize,
                pages: parseInt(totalpaginate),
                loading: false
            })
        } catch (e: any) {
            handleError(e)
        }
    }

    return (
        <div className="">
            <div className="row mb-5">
                <div className="col-12 text-end">
                    <a href={toAbsoluteUrl("/media/assets/4-Arancel-MLE-2026.xlsx")} className="btn border bg-white fw-bold">
                        Norma Tecnica
                        <img src={toAbsoluteUrl("/media/icons/732220.png")} alt="" className=' ms-3 w-30px' />
                    </a>
                </div>
            </div>

            <Search _handleSearch={(values: any) => _handleGetData(state.pageIndex, state.pageSize, values)} _handleError={handleError} loading={state.loading} />
            <div className="card card-xl-stretch mb-xl-8 mt-5">

                <Table data={state.data} headers={state.headers} loading={state.loading} />

                {state.headers?.length > 0 ? (
                    <div className="my-5">
                        <PaginationComponent totalPages={state.pages} activePage={state.pageIndex} searchData={_handleGetData} loading={state.loading} />
                    </div>
                ) : null}
            </div>

            <AlertDialog
              message={messageAlertError}
              show={showAlertError}
              success={false}
              onConfirm={() => {
                  setShowAlertError(false);
              }}
            />
        </div>
    );
}

export default Tariff;